import { Chart } from '@antv/g2'
import { DataView } from '@antv/data-set'

export { Chart, DataView }
